import React, { useRef, useState } from 'react';
import { Button } from 'reactstrap';
import { BsUpload, BsFileEarmarkCheck } from 'react-icons/bs';
import LoadingButton from '../LoadingButton';

const BulkUpload = ({
  onUpload,
  onDiscard,
  loading = false,
  topContainerClassName = 'bulk-upload',
  descriptionText,
  supportedFormatText,
  templateText,
  submitButtonText,
}) => {
  const fileInputRef = useRef(null);
  const [file, setFile] = useState(null);
  const [fileName, setFileName] = useState('');
  const [error, setError] = useState('');
  const handleUploadClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (!selectedFile) return;

    // Check if the file is an Excel file
    if (!selectedFile.name.endsWith('.xlsx')) {
      setError('Please upload an Excel (.xlsx) file');
      return;
    }

    // Check if the file size is more than 5 MB
    const maxSize = 5 * 1024 * 1024; // 5 MB in bytes
    if (selectedFile.size > maxSize) {
      setError('File size should not exceed 5 MB');
      return;
    }

    setFile(selectedFile);
    setFileName(selectedFile.name);
    setError('');
  };

  const crossButton = () => {
    return (
      <svg
        style={{ cursor: 'pointer' }}
        onClick={() => {
          setFile(null);
          setFileName('');
          setError('');
        }}
        width="15"
        height="14"
        viewBox="0 0 15 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_2_8883)">
          <rect
            x="1"
            y="0.5"
            width="13"
            height="13"
            rx="1"
            fill="white"
            fill-opacity="0.01"
          />
          <rect
            width="14"
            height="14"
            transform="translate(0.5)"
            fill="white"
            fill-opacity="0.01"
          />
        </g>
        <rect x="1" y="0.5" width="13" height="13" rx="1" stroke="#B02A37" />
        <mask id="path-2-inside-1_2_8883" fill="white">
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M10.7089 3.83164C10.7352 3.85784 10.756 3.88896 10.7703 3.92322C10.7845 3.95749 10.7918 3.99422 10.7918 4.03132C10.7918 4.06841 10.7845 4.10515 10.7703 4.13941C10.756 4.17368 10.7352 4.2048 10.7089 4.231L4.50419 10.4357C4.45123 10.4887 4.37941 10.5185 4.30451 10.5185C4.22962 10.5185 4.15779 10.4887 4.10483 10.4357C4.05187 10.3828 4.02212 10.311 4.02212 10.2361C4.02212 10.1612 4.05187 10.0893 4.10483 10.0364L10.3096 3.83164C10.3358 3.80537 10.3669 3.78453 10.4012 3.77032C10.4354 3.7561 10.4722 3.74878 10.5093 3.74878C10.5464 3.74878 10.5831 3.7561 10.6174 3.77032C10.6516 3.78453 10.6827 3.80537 10.7089 3.83164Z"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M4.10483 3.83164C4.07857 3.85784 4.05773 3.88896 4.04351 3.92322C4.02929 3.95749 4.02197 3.99422 4.02197 4.03132C4.02197 4.06841 4.02929 4.10515 4.04351 4.13941C4.05773 4.17368 4.07857 4.2048 4.10483 4.231L10.3096 10.4357C10.3625 10.4887 10.4344 10.5185 10.5093 10.5185C10.5842 10.5185 10.656 10.4887 10.7089 10.4357C10.7619 10.3828 10.7916 10.311 10.7916 10.2361C10.7916 10.1612 10.7619 10.0893 10.7089 10.0364L4.50419 3.83164C4.47799 3.80537 4.44687 3.78453 4.41261 3.77032C4.37834 3.7561 4.34161 3.74878 4.30451 3.74878C4.26741 3.74878 4.23068 3.7561 4.19642 3.77032C4.16215 3.78453 4.13103 3.80537 4.10483 3.83164Z"
          />
        </mask>
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.7089 3.83164C10.7352 3.85784 10.756 3.88896 10.7703 3.92322C10.7845 3.95749 10.7918 3.99422 10.7918 4.03132C10.7918 4.06841 10.7845 4.10515 10.7703 4.13941C10.756 4.17368 10.7352 4.2048 10.7089 4.231L4.50419 10.4357C4.45123 10.4887 4.37941 10.5185 4.30451 10.5185C4.22962 10.5185 4.15779 10.4887 4.10483 10.4357C4.05187 10.3828 4.02212 10.311 4.02212 10.2361C4.02212 10.1612 4.05187 10.0893 4.10483 10.0364L10.3096 3.83164C10.3358 3.80537 10.3669 3.78453 10.4012 3.77032C10.4354 3.7561 10.4722 3.74878 10.5093 3.74878C10.5464 3.74878 10.5831 3.7561 10.6174 3.77032C10.6516 3.78453 10.6827 3.80537 10.7089 3.83164Z"
          fill="#FC6977"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M4.10483 3.83164C4.07857 3.85784 4.05773 3.88896 4.04351 3.92322C4.02929 3.95749 4.02197 3.99422 4.02197 4.03132C4.02197 4.06841 4.02929 4.10515 4.04351 4.13941C4.05773 4.17368 4.07857 4.2048 4.10483 4.231L10.3096 10.4357C10.3625 10.4887 10.4344 10.5185 10.5093 10.5185C10.5842 10.5185 10.656 10.4887 10.7089 10.4357C10.7619 10.3828 10.7916 10.311 10.7916 10.2361C10.7916 10.1612 10.7619 10.0893 10.7089 10.0364L4.50419 3.83164C4.47799 3.80537 4.44687 3.78453 4.41261 3.77032C4.37834 3.7561 4.34161 3.74878 4.30451 3.74878C4.26741 3.74878 4.23068 3.7561 4.19642 3.77032C4.16215 3.78453 4.13103 3.80537 4.10483 3.83164Z"
          fill="#FC6977"
        />
        <path
          d="M10.7089 3.83164L10.0009 4.53785L10.0027 4.53964L10.7089 3.83164ZM10.7703 3.92322L11.6939 3.53995V3.53995L10.7703 3.92322ZM10.7089 4.231L10.0027 3.523L10.0018 3.52389L10.7089 4.231ZM4.50419 10.4357L5.2113 11.1429L5.2113 11.1429L4.50419 10.4357ZM4.10483 10.4357L3.39772 11.1429L4.10483 10.4357ZM4.02212 10.2361H3.02212H4.02212ZM4.10483 10.0364L4.81194 10.7435L4.81194 10.7435L4.10483 10.0364ZM10.3096 3.83164L11.0167 4.53874L11.0176 4.53785L10.3096 3.83164ZM10.4012 3.77032L10.7844 4.69395L10.4012 3.77032ZM10.5093 3.74878V4.74878V3.74878ZM10.6174 3.77032L10.2341 4.69395L10.6174 3.77032ZM4.10483 3.83164L4.81105 4.53964L4.81283 4.53785L4.10483 3.83164ZM4.04351 3.92322L3.11987 3.53996L3.11987 3.53996L4.04351 3.92322ZM4.02197 4.03132H3.02197H4.02197ZM4.04351 4.13941L4.96715 3.75614V3.75614L4.04351 4.13941ZM4.10483 4.231L4.81194 3.52389L4.81104 3.523L4.10483 4.231ZM10.3096 10.4357L11.0167 9.72864L10.3096 10.4357ZM10.7089 10.0364L11.416 9.32928L10.7089 10.0364ZM4.50419 3.83164L3.79619 4.53785L3.79708 4.53874L4.50419 3.83164ZM4.41261 3.77032L4.02934 4.69395H4.02934L4.41261 3.77032ZM4.30451 3.74878V2.74878V3.74878ZM4.19642 3.77032L3.81315 2.84668L3.81315 2.84668L4.19642 3.77032ZM10.0027 4.53964C9.93586 4.47294 9.88282 4.39371 9.84662 4.30649L11.6939 3.53995C11.6293 3.3842 11.5345 3.24273 11.4152 3.12364L10.0027 4.53964ZM9.84662 4.30649C9.81043 4.21926 9.7918 4.12575 9.7918 4.03132H11.7918C11.7918 3.86269 11.7585 3.69571 11.6939 3.53995L9.84662 4.30649ZM9.7918 4.03132C9.7918 3.93688 9.81043 3.84337 9.84662 3.75614L11.6939 4.52268C11.7585 4.36692 11.7918 4.19995 11.7918 4.03132H9.7918ZM9.84662 3.75614C9.88282 3.66892 9.93586 3.58969 10.0027 3.523L11.4152 4.939C11.5345 4.81991 11.6293 4.67843 11.6939 4.52268L9.84662 3.75614ZM10.0018 3.52389L3.79708 9.72864L5.2113 11.1429L11.416 4.9381L10.0018 3.52389ZM3.79709 9.72864C3.93166 9.59406 4.11419 9.51846 4.30451 9.51846V11.5185C4.64462 11.5185 4.9708 11.3833 5.2113 11.1429L3.79709 9.72864ZM4.30451 9.51846C4.49483 9.51846 4.67736 9.59406 4.81194 9.72864L3.39772 11.1429C3.63822 11.3833 3.9644 11.5185 4.30451 11.5185V9.51846ZM4.81194 9.72864C4.94652 9.86322 5.02212 10.0457 5.02212 10.2361H3.02212C3.02212 10.5762 3.15723 10.9024 3.39772 11.1429L4.81194 9.72864ZM5.02212 10.2361C5.02212 10.4264 4.94652 10.6089 4.81194 10.7435L3.39772 9.32928C3.15723 9.56978 3.02212 9.89596 3.02212 10.2361H5.02212ZM4.81194 10.7435L11.0167 4.53874L9.60247 3.12453L3.39772 9.32928L4.81194 10.7435ZM11.0176 4.53785C10.9509 4.60471 10.8717 4.65776 10.7844 4.69395L10.0179 2.84668C9.86215 2.91131 9.72067 3.00603 9.60158 3.12542L11.0176 4.53785ZM10.7844 4.69395C10.6972 4.73015 10.6037 4.74878 10.5093 4.74878V2.74878C10.3406 2.74878 10.1737 2.78205 10.0179 2.84668L10.7844 4.69395ZM10.5093 4.74878C10.4148 4.74878 10.3213 4.73015 10.2341 4.69395L11.0006 2.84668C10.8449 2.78205 10.6779 2.74878 10.5093 2.74878V4.74878ZM10.2341 4.69395C10.1469 4.65776 10.0676 4.60471 10.0009 4.53785L11.4169 3.12542C11.2978 3.00603 11.1564 2.91131 11.0006 2.84668L10.2341 4.69395ZM3.39862 3.12364C3.27923 3.24273 3.1845 3.3842 3.11987 3.53996L4.96715 4.30649C4.93095 4.39372 4.87791 4.47294 4.81104 4.53964L3.39862 3.12364ZM3.11987 3.53996C3.05524 3.69571 3.02197 3.86269 3.02197 4.03132H5.02197C5.02197 4.12576 5.00334 4.21926 4.96715 4.30649L3.11987 3.53996ZM3.02197 4.03132C3.02197 4.19995 3.05524 4.36692 3.11987 4.52268L4.96715 3.75614C5.00334 3.84337 5.02197 3.93688 5.02197 4.03132H3.02197ZM3.11987 4.52268C3.1845 4.67843 3.27923 4.81991 3.39862 4.939L4.81104 3.523C4.87791 3.58969 4.93095 3.66892 4.96715 3.75614L3.11987 4.52268ZM3.39772 4.9381L9.60247 11.1429L11.0167 9.72864L4.81194 3.52389L3.39772 4.9381ZM9.60247 11.1429C9.84297 11.3833 10.1692 11.5185 10.5093 11.5185V9.51846C10.6996 9.51846 10.8821 9.59406 11.0167 9.72864L9.60247 11.1429ZM10.5093 11.5185C10.8494 11.5185 11.1756 11.3833 11.416 11.1429L10.0018 9.72864C10.1364 9.59406 10.3189 9.51846 10.5093 9.51846V11.5185ZM11.416 11.1429C11.6565 10.9024 11.7916 10.5762 11.7916 10.2361H9.79165C9.79165 10.0457 9.86725 9.86322 10.0018 9.72864L11.416 11.1429ZM11.7916 10.2361C11.7916 9.89596 11.6565 9.56978 11.416 9.32928L10.0018 10.7435C9.86725 10.6089 9.79165 10.4264 9.79165 10.2361H11.7916ZM11.416 9.32928L5.2113 3.12453L3.79708 4.53874L10.0018 10.7435L11.416 9.32928ZM5.21219 3.12542C5.0931 3.00603 4.95163 2.91131 4.79587 2.84668L4.02934 4.69395C3.94211 4.65776 3.86288 4.60471 3.79619 4.53785L5.21219 3.12542ZM4.79587 2.84668C4.64012 2.78205 4.47314 2.74878 4.30451 2.74878V4.74878C4.21007 4.74878 4.11656 4.73015 4.02934 4.69395L4.79587 2.84668ZM4.30451 2.74878C4.13588 2.74878 3.9689 2.78205 3.81315 2.84668L4.57968 4.69395C4.49246 4.73015 4.39895 4.74878 4.30451 4.74878V2.74878ZM3.81315 2.84668C3.6574 2.91131 3.51592 3.00603 3.39683 3.12542L4.81283 4.53785C4.74614 4.60471 4.66691 4.65776 4.57968 4.69395L3.81315 2.84668Z"
          fill="#B02A37"
          mask="url(#path-2-inside-1_2_8883)"
        />
        <defs>
          <clipPath id="clip0_2_8883">
            <rect x="1" y="0.5" width="13" height="13" rx="1" fill="white" />
          </clipPath>
        </defs>
      </svg>
    );
  };

  return (
    <div className={topContainerClassName}>
      {descriptionText && (
        <span className="description">{descriptionText}</span>
      )}
      <div className="upload-button-container">
        <svg
          width="32"
          height="33"
          viewBox="0 0 32 33"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M26.0039 11.5921C26.0039 12.1946 25.5155 12.683 24.913 12.683H6.94866C6.10888 12.683 5.58401 11.7739 6.00393 11.0466C6.19882 10.7091 6.55894 10.5012 6.94866 10.5012H24.913C25.5155 10.5012 26.0039 10.9897 26.0039 11.5921ZM19.0592 14.8649H6.94867C6.10888 14.8649 5.58402 15.774 6.00391 16.5012C6.19877 16.8387 6.55894 17.0467 6.94867 17.0467H19.0592C19.899 17.0466 20.4239 16.1375 20.0039 15.4103C19.8091 15.0728 19.4489 14.8649 19.0592 14.8649ZM30.3676 6.68303V26.3194C30.3676 27.5244 29.3907 28.5012 28.1857 28.5012H4.18573C2.9807 28.5013 2.00391 27.5244 2.00391 26.3194V6.68303C2.00391 5.47805 2.98074 4.50122 4.18573 4.50122H28.1857C29.3907 4.50122 30.3676 5.47805 30.3676 6.68303ZM28.1857 26.3194V6.68303H4.18573V26.3194H28.1857Z"
            fill="#6C757D"
          />
          <path
            d="M19.0592 19.2785H6.94866C6.10888 19.2785 5.58401 20.1876 6.00391 20.9149C6.19877 21.2524 6.55893 21.4603 6.94866 21.4603H19.0592C19.899 21.4603 20.4239 20.5512 20.0039 19.8239C19.8091 19.4864 19.4489 19.2785 19.0592 19.2785Z"
            fill="#6C757D"
          />
        </svg>

        <input
          type="file"
          ref={fileInputRef}
          onChange={handleFileChange}
          accept=".xlsx"
          style={{ display: 'none' }}
        />

        {!file && (
          <>
            {' '}
            <button
              onClick={handleUploadClick}
              type="button"
              className="upload-button"
            >
              <BsUpload size={16} />
              <span>Upload</span>
            </button>
            {supportedFormatText && (
              <span className="supported-format">{supportedFormatText}</span>
            )}
            {templateText && <span className="template">{templateText}</span>}
          </>
        )}

        {file && (
          <div className="file-info">
            <BsFileEarmarkCheck size={16} />
            <span>{fileName}</span>
            {crossButton()}
          </div>
        )}
        {error && (
          <span style={{ color: '#B02A37', fontWeight: 400 }}>{error}</span>
        )}
      </div>
      <div className="d-flex justify-content-end">
        <Button
          outline
          onClick={onDiscard}
          color="secondary"
          type="button"
          size="sm"
          className="me-2 mw-100"
        >
          Discard
        </Button>
        <LoadingButton
          className="mw-100 loading-button"
          loading={loading}
          disabled={!file}
          color="primary"
          size="sm"
          type="button"
          onClick={async () => {
            await onUpload(file);
            setFile(null);
            setFileName('');
            setError('');
            onDiscard();
          }}
        >
          {submitButtonText}
        </LoadingButton>
      </div>
    </div>
  );
};

export default BulkUpload;
